import React from 'react';
import {useIntl} from 'react-intl';

import {Badge} from './badge';

type Props = {
    className?: string;
    show?: boolean;
}

export const BotBadge = ({className = '', show = true}: Props) => {
    const {formatMessage} = useIntl();

    const message = formatMessage({
        id: 'post_info.bot',
        defaultMessage: 'Bot',
    });

    return (
        <Badge className={className} show={show}>
            {message}
        </Badge>
    );
};
